export const dealerRegistrationStatuses = [
  'Register',
  'Continue',
  'ContinueByOther',
  'Affiliate',
];

export const LAST4_PHOTO_ID_SESSION_KEY = 'aa-last4-photo-id';
export const AUCTION_ACCESS_ID_SESSION_KEY = 'aa-auction-access-id';

const auctionAccess = {
  state: {
    auctionAccessId: sessionStorage.getItem(AUCTION_ACCESS_ID_SESSION_KEY) ?? -1,
    last4PhotoId: sessionStorage.getItem(LAST4_PHOTO_ID_SESSION_KEY) ?? -1,
    organizations: [],
    firstName: null,
    lastName: null,
    dealerEmail: null,
    maskedEmail: null,
    codeTtlSeconds: null,
    preferredLanguage: null,
    googleConversionInfo: {
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmTerm: null,
      googleClickId: null,
    },
    allIssues: [],
    personIssues: [],
    dealerIssues: [],
    selectedDealer: null,
    organizationAcvId: null,
  },
  mutations: {
    setAAId(state, value) {
      state.auctionAccessId = value;
      if (value === null || value === undefined || value === -1) {
        sessionStorage.removeItem(AUCTION_ACCESS_ID_SESSION_KEY);
      } else {
        sessionStorage.setItem(AUCTION_ACCESS_ID_SESSION_KEY, value);
      }
    },
    setPhotoId(state, value) {
      state.last4PhotoId = value;
      if (value === null || value === undefined || value === -1) {
        sessionStorage.removeItem(LAST4_PHOTO_ID_SESSION_KEY);
      } else {
        sessionStorage.setItem(LAST4_PHOTO_ID_SESSION_KEY, value);
      }
    },
    setDealerEmail(state, value) {
      state.dealerEmail = value;
    },
    setCodeTtlSeconds(state, value) {
      state.codeTtlSeconds = value;
    },
    setAAInfo(state, value) {
      const {
        firstName = state.firstName,
        lastName = state.lastName,
        organizations = state.organizations,
        preferredLanguage = state.preferredLanguage,
        email = state.dealerEmail,
        maskedEmail = state.maskedEmail,
        issues = state.personIssues,
      } = value;
      state.firstName = firstName;
      state.lastName = lastName;
      state.organizations = organizations;
      state.preferredLanguage = preferredLanguage;
      state.dealerEmail = email;
      state.maskedEmail = maskedEmail;
      state.personIssues = issues;
    },
    setGoogleConversionInfo(state, value) {
      state.googleConversionInfo = { ...value };
    },
    setAuctionAccessIssues(state, value) {
      const {
        allIssues,
        dealerIssues,
        personsIssues,
      } = value;
      state.allIssues = allIssues;
      state.dealerIssues = dealerIssues;
      state.personIssues = personsIssues;
    },
    setSelectedDealer(state, dealer) {
      state.selectedDealer = dealer;
    },
    setOrganizationAcvId(state, value) {
      state.organizationAcvId = value;
    },
    clearAllAAData(state) {
      state.auctionAccessId = -1;
      sessionStorage.removeItem(AUCTION_ACCESS_ID_SESSION_KEY);
      state.last4PhotoId = -1;
      sessionStorage.removeItem(LAST4_PHOTO_ID_SESSION_KEY);
      state.organizations = [];
      state.firstName = null;
      state.lastName = null;
      state.dealerEmail = null;
      state.maskedEmail = null;
      state.codeTtlSeconds = null;
      state.preferredLanguage = null;
      state.personIssues = [];
      state.dealerIssues = [];
      state.selectedDealer = null;
      state.organizationAcvId = null;
    },
    clearGoogleConversionInfo(state) {
      state.googleConversionInfo = {
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmTerm: null,
        googleClickId: null,
      };
    },
  },
  actions: {
    clearAllAAData({ commit }) {
      commit('clearAllAAData');
    },
    clearGoogleConversionInfo({ commit }) {
      commit('clearGoogleConversionInfo');
    },
    updateAAId({ commit }, value) {
      commit('setAAId', value);
    },
    updatePhotoId({ commit }, value) {
      commit('setPhotoId', value);
    },
    updateCodeTtlSeconds({ commit }, value) {
      commit('setCodeTtlSeconds', value);
    },
    updateAAInfo({ commit }, value) {
      commit('setAAInfo', value);
    },
    updateGoogleConversionInfo({ commit }, value) {
      commit('setGoogleConversionInfo', value);
    },
    updateAuctionAccessIssues({ commit }, value) {
      commit('setAuctionAccessIssues', value);
    },
    updateSelectedDealer({ commit }, dealer) {
      commit('setSelectedDealer', dealer);
    },
    updateOrganizationAcvId({ commit }, value) {
      commit('setOrganizationAcvId', value);
    },
  },
  getters: {
    auctionAccessId: (state) => state.auctionAccessId,
    last4PhotoId: (state) => state.last4PhotoId,
    aaOrganizations: (state) => state.organizations,
    aaFirstName: (state) => state.firstName,
    aaLastName: (state) => state.lastName,
    dealerEmail: (state) => state.dealerEmail,
    maskedEmail: (state) => state.maskedEmail,
    codeTtlSeconds: (state) => state.codeTtlSeconds,
    preferredLanguage: (state) => state.preferredLanguage,
    googleConversionInfo: (state) => state.googleConversionInfo,
    aaAllIssues: (state) => state.allIssues,
    aaPersonIssues: (state) => state.personIssues,
    aaDealerIssues: (state) => state.dealerIssues,
    selectedDealer: (state) => state.selectedDealer,
    organizationAcvId: (state) => state.organizationAcvId,
    isMultiDealer: (state) => state.organizations && state.organizations.length > 1,
    hasUnregisteredDealerships: (state) => state.organizations?.some(
      (org) => dealerRegistrationStatuses.includes(org.registrationAction),
    ),
  },
};

export const {
  mutations, actions, state, getters,
} = auctionAccess;

export default auctionAccess;
